import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ModalController, PopoverController} from '@ionic/angular';
import {AccountPaymentFavoriteService} from '@wlp/ui-bs-account-payment-favorite';
import {BilletLotService, BilletProtestTypeEnum, BilletService} from '@wlp/ui-bs-cashin';
import {UserInfoService} from '@wlp/ui-bs-login';
import {ProtestDto} from '@wlp/ui-px-cashin';
import * as moment from 'moment';
import {LoadingService} from 'src/app/core/layout/services/loading.service';
import {UiBsTranslateService} from '@wlp/ui-bs-translate';

@Component({
  selector: 'ui-t-form-protest',
  templateUrl: './form-protest.html',
  styleUrls: ['./form-protest.scss'],
})
export class FormProtest implements OnInit {

  @Input() public protest: ProtestDto;
  @Output() public submitForm = new EventEmitter<string>();
  @Output() public onCancel = new EventEmitter<string>();
  public enableProtest = false;
  public protestForm: FormGroup;
  public errorMessages: any;
  public customPopoverOptionsProtestTypeSelect: any;

  public proptestOptions = Object.keys(BilletProtestTypeEnum).map((protest) => ({
    key: protest,
    label: `CASH_OUT.BILLET_DETAILED_PAGE.PROTEST.SELECT_OPTIONS.${protest}`,
  }));

  constructor(
    private formBuilder: FormBuilder,
    public modalController: ModalController,
    public popoverController: PopoverController,
    public router: Router,
    protected userInfoService: UserInfoService,
    private translate: UiBsTranslateService,
    public billetService: BilletService,
    public billetLotService: BilletLotService,
    public accountPaymentFavoriteService: AccountPaymentFavoriteService,
    private cd: ChangeDetectorRef,
    private loadingService: LoadingService,
  ) {
    moment.locale('pt-br');
  }

  public ngOnInit() {
    this.customPopoverOptionsProtestTypeSelect = {
      header: this.translate.applyTranslate('CASH_OUT.BILLET_DETAILED_PAGE.PROTEST.TYPE'),
    };

    this.setErrorMessages();
    this.createProtestForm();
    if (this.protest && this.protest.type) {
      this.enableProtest = true;
      this.protestForm.controls.protestType.setValidators(Validators.required);
    }
    this.onChangeSelectValue(this.protest.type);
  }

  public protestBlockedField() {
    const protestType = this.protestForm.controls.protestType.value;
    return protestType === 'NOT_PROTEST' || protestType === 'CANCEL_PROTEST' || protestType === '';
  }

  public setErrorMessages() {
    const protestDaysValidation = [
      {
        type: 'required',
        message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.REQUIRED',
      },
      {
        type: 'min',
        message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.MIN_NUMBER',
        param: {min: 1},
      },
      {
        type: 'max',
        message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.MAX_NUMBER',
        param: {max: 99},
      },
    ];

    this.errorMessages = {
      protestType:  {
        type: 'required',
        message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.REQUIRED',
      },
      protestDays:  protestDaysValidation,
    };
  }

  public onChangeSelectValue(protestType) {
    const protestDaysControl = this.protestForm.controls.protestDays;

    if (protestType === 'EFFECTIVE_PROTEST') {
      protestDaysControl.setValidators(Validators.compose([Validators.min(1), Validators.max(99), Validators.required]));
      protestDaysControl.markAsTouched();
      protestDaysControl.updateValueAndValidity();
    } else if (protestType === 'NOT_PROTEST') {
      protestDaysControl.clearValidators();
      protestDaysControl.setValue('');
      protestDaysControl.markAsTouched();
      protestDaysControl.updateValueAndValidity();
    } else {
      protestDaysControl.clearValidators();
      protestDaysControl.markAsTouched();
      protestDaysControl.updateValueAndValidity();
    }
  }

  public createProtestForm() {
    this.protestForm = this.formBuilder.group({
      protestType: new FormControl(this.protest ? this.protest.type : ''),
      protestDays: new FormControl(this.protest ? this.protest.days : ''),
    });
    this.loadingService.hide();
  }

  public handleClickSaveButton() {
    this.submitForm.emit();
  }

  public cancel() {
    this.onCancel.emit();
  }

}
